import React from "react";
import {OverlayTrigger, Popover} from 'react-bootstrap';

export default function PopoverTrigger({header, content, placement, triggerIcon, triggerIconStyleClasses}) {

    const renderPopoverHeader = () => {
        if(header) {
            return (
                <Popover.Header as="h3">{header}</Popover.Header>
            )
        }
    }

    const renderPopover = () => {
        return (
            <Popover id="popover-basic">
                {renderPopoverHeader()}
                <Popover.Body>
                    {content}
                </Popover.Body>
            </Popover>
        )
    }

    return (
        <>
            <OverlayTrigger placement={placement} overlay={renderPopover()}>
                <i className={`${triggerIconStyleClasses} ${triggerIcon}`} style={{ cursor: 'pointer'}}></i>
            </OverlayTrigger>
        </>
    )
}